import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'icons-section';
const BLOCK_ID = 'icons-section';
const PLACEHOLDER_LABEL = 'Icons';

export default function iconsSection(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-icons-section') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                return { type: COMPONENT_TYPE };
            }
            return undefined;
        },

        model: {
            defaults: {
                tagName: 'div',
                name: 'Icons',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-jd-icons',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [
                    {
                        type: 'text',
                        label: 'Kategoriename',
                        name: 'categoryName',
                        default: '',
                        changeProp: 1,
                    },
                    {
                        type: 'text',
                        label: 'Abschnittstitel',
                        name: 'sectionTitle',
                        default: '',
                        changeProp: 1,
                    },
                ],
            },
        },
        view: {},
    });

    blockManager.add(BLOCK_ID, {
        label: 'Icons',
        category: blockCategories.journeyDetail,
        media: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8Zm-1-13h2v2h-2V7Zm0 4h2v6h-2v-6Z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-jd-icons',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
